<dx-toolbar #toolbar [dataSource]="toolbarDs" class="trailer-interventions-toolbar">
  <div *dxTemplate="let data of 'toolbarTitle'">
    <h1 class="flex flex-wrap items-center grid-title">Rapport Parcelles</h1>
  </div>

  <div *dxTemplate="let data of 'toolbarReportTypeSelect'">
    <!--<div class="flex flex-row mr-4 items-center">
      <span class="block mr-2 text-sm font-medium">Type: </span>
      -->
    <dx-select-box
      width="400"
      displayExpr="label"
      stylingMode="underlined"
      placeholder="Type"
      [grouped]="true"
      [(value)]="currentReportType"
      (onValueChanged)="reportTypeChanged($event)"
      [dataSource]="reportsDs">
    </dx-select-box>
    <!--</div>-->
  </div>

  <div *dxTemplate="let data of 'toolbarReportViewModeSelect'">

    <!--<div class="flex flex-row mr-4 items-center">
      <span class="block mr-2 text-sm font-medium">Vue: </span>-->
    <dx-button-group
      [items]="viewModes"
      keyExpr="value"
      stylingMode="text"
      [(selectedItemKeys)]="reportCurrentViewModes"
      (onItemClick)="viewModeClick($event)">
    </dx-button-group>
    <!--</div>-->
  </div>
</dx-toolbar>

<app-fields-interventions-general-report
  *ngIf="currentReportType.value === 'general'"
  [currentReportType]="currentReportType"
  [reportCurrentViewModes]="reportCurrentViewModes"
  [dataSource]="dataSource"
  [height]="height"
  [width]="width"
  [toolbarDs]="toolbarDs">
</app-fields-interventions-general-report>

<app-fields-interventions-general-ii-report
  *ngIf="currentReportType.value === 'general-ii'"
  [currentReportType]="currentReportType"
  [reportCurrentViewModes]="reportCurrentViewModes"
  [store]="store"
  [request]="request"
  [height]="height"
  [width]="width"
  [toolbarDs]="toolbarDs"
  [dataSource]="dataSource">
</app-fields-interventions-general-ii-report>

<app-fields-interventions-tractors-speed-working-area-time-report
  *ngIf="currentReportType.value === 'monthly-tractor-work-area'"
  [currentReportType]="currentReportType"
  [reportCurrentViewModes]="reportCurrentViewModes"
  [dataSource]="dataSource"
  [height]="height"
  [width]="width"
  [toolbarDs]="toolbarDs">
</app-fields-interventions-tractors-speed-working-area-time-report>

<app-fields-interventions-operations-progress-report
  *ngIf="currentReportType.value === 'operations-progress'"
  [currentReportType]="currentReportType"
  [reportCurrentViewModes]="reportCurrentViewModes"
  [dataSource]="dataSource"
  [height]="height"
  [width]="width"
  [toolbarDs]="toolbarDs">
</app-fields-interventions-operations-progress-report>

<app-fields-interventions-speed-per-operation-trailer-report
  *ngIf="currentReportType.value === 'speed-per-operation-trailer'"
  [currentReportType]="currentReportType"
  [reportCurrentViewModes]="reportCurrentViewModes"
  [dataSource]="dataSource"
  [height]="height"
  [width]="width"
  [toolbarDs]="toolbarDs">
</app-fields-interventions-speed-per-operation-trailer-report>

<app-fields-interventions-throughput-per-operation-trailer-report
  *ngIf="currentReportType.value === 'throughput-per-operation-trailer'"
  [currentReportType]="currentReportType"
  [reportCurrentViewModes]="reportCurrentViewModes"
  [dataSource]="dataSource"
  [height]="height"
  [width]="width"
  [toolbarDs]="toolbarDs">
</app-fields-interventions-throughput-per-operation-trailer-report>

<app-fields-interventions-time-repartition-report
  *ngIf="currentReportType.value === 'time-repartition'"
  [currentReportType]="currentReportType"
  [reportCurrentViewModes]="reportCurrentViewModes"
  [dataSource]="dataSource"
  [height]="height"
  [width]="width"
  [toolbarDs]="toolbarDs">
</app-fields-interventions-time-repartition-report>


<app-fields-interventions-tractors-trailer-width-choice-report
  *ngIf="currentReportType.value === 'tractors-trailer-width-choice'"
  [currentReportType]="currentReportType"
  [reportCurrentViewModes]="reportCurrentViewModes"
  [dataSource]="dataSource"
  [height]="height"
  [width]="width"
  [toolbarDs]="toolbarDs">
</app-fields-interventions-tractors-trailer-width-choice-report>

<app-fields-interventions-tractors-usage-report
  *ngIf="currentReportType.value === 'tractors-usage'"
  [currentReportType]="currentReportType"
  [reportCurrentViewModes]="reportCurrentViewModes"
  [dataSource]="dataSource"
  [height]="height"
  [width]="width"
  [toolbarDs]="toolbarDs">
</app-fields-interventions-tractors-usage-report>

<app-fields-interventions-fuel-consumption-per-operation-report
  *ngIf="currentReportType.value === 'fuel-consumption-per-operation'"
  [currentReportType]="currentReportType"
  [reportCurrentViewModes]="reportCurrentViewModes"
  [dataSource]="dataSource"
  [height]="height"
  [width]="width"
  [toolbarDs]="toolbarDs">
</app-fields-interventions-fuel-consumption-per-operation-report>
